/* eslint-disable react-hooks/exhaustive-deps */
import { set, isArray } from 'lodash';
import React, { createContext, useContext, useState, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import useFPSalesHooks from '../Hooks/FPSalesHooks';
import useMdCalculationHooks from '../Hooks/MdHooks';
import useMonthlyPlanningHooks from '../Hooks/MonthlyPlanSellingHooks';
import useTerminalCalculationHooks from '../Hooks/useTerminalCalculationHooks';
import { useComponent } from '../../UserSetting/UsersLibrary/UserRights';

export const StateContext = createContext(null);

export default function PlanningActualProvider({ children, ...props }) {
  const reducer = useSelector((estate) => estate);

  const category1 = 'Category 1';
  const category2 = 'Category 2';
  const category3 = 'Category 3';
  const category4 = 'Category 4';

  const {
    PlanningBottomReducer,
    Users: { logInRights },
    UserDetails: { isCompanyAdminLoggedIn },
  } = reducer;
  const { PlanningBottomData } = PlanningBottomReducer;
  const { caluculateTotalPWS } = useMonthlyPlanningHooks();
  const { caluculateFPSSales } = useFPSalesHooks();
  const { calculateTerminal } = useTerminalCalculationHooks();
  const { calculateMd } = useMdCalculationHooks();
  const pathName1 = window.origin;
  const [lengthEnabled, setLengthEnabled] = useState(true);

  const { CheckActionPermission, CheckModulePermission } = useComponent();

  const initialSetting = {
    currLevel: null,
    planningBottomProducts: [],
    levelOptions: [
      { name: category1, _id: 'Cat1', level: 1 },
      { name: category2, _id: 'Cat2', level: 2 },
      { name: category3, _id: 'Cat3', level: 3 },
      { name: category4, _id: 'Cat4', level: 4 },
      { name: 'Product', _id: 'product', level: 5 },
      { name: 'Colourway', _id: 'colourway', level: 6 },
      { name: 'Size', _id: 'size', level: 7 },
      { name: 'Length', _id: 'length', level: 8 },
    ],
    selectedLevel: null,
    changed: true,
    staticPlanningBottomUpKeys: ['planSelling', 'fpRos', 'stores', 'fpSlsMix', 'markDown', 'terminal', 'sizeRatio', 'lengthRatio', 'channels'],
    autoCalculatedObj: [
      'fpSalesUnits',
      'fpSalesValue',
      'mdSalesUnits',
      'mdSalesValue',
      'terminalUnits',
      'totalUKBuyUnits',
      'ukRetailCv',
      'ukRetailSvNet',
      'ukRetailSvGross',
      'unitsRetail',
      'costRetail',
      'costGlobal',
      'totalSalesValue',
      'unitsGlobal',
      'costGlobal',
      'unitMOQShortfall',
      'costMOQShortfall',
    ],
    displayColumns: [
      // {
      //   label: "Product Number",
      //   existlevel: 5,
      //   value: "number",
      // },
      // {
      //   label: "Suffix",
      //   existlevel: 6,
      //   value: "suffix",
      // },
      // {
      //   label: "Costing Code",
      //   existlevel: 5,
      //   value: "costing",
      // },
      { label: 'SKU', existlevel: 7, value: 'SKU' },
      {
        label: category1,
        existlevel: 1,
        value: 'catOneId',
        hideShow: false,
      },
      {
        label: category2,
        existlevel: 2,
        value: 'catTwoId',
        hideShow: false,
      },
      {
        label: category3,
        existlevel: 3,
        value: 'catThreeId',
        hideShow: false,
      },
      {
        label: category4,
        existlevel: 4,
        value: 'catFourId',
        hideShow: false,
      },
      {
        label: 'Product Description',
        existlevel: 5,
        value: 'description',
      },
      {
        label: 'Colour Name',
        existlevel: 6,
        value: 'colour',
      },
      {
        label: 'Colour Description',
        existlevel: 6,
        value: 'colour',
      },
      {
        label: 'Colour Ref',
        existlevel: 6,
        value: 'colour',
      },
      { label: 'Size', existlevel: 7, value: 'size' },
      {
        label: 'Length',
        existlevel: 8,
        value: 'length',
      },
      // { label: "RRP", existlevel: 5, value: "rrp" },
      // { label: "GBB", existlevel: 5, value: "gbb" },
      {
        label: 'Season',
        existlevel: 1,
        value: 'seasonId',
      },
      { label: 'Year', existlevel: 1, value: 'year' },
      { label: 'MOQ', existlevel: 5, value: 'moq' },
      // { label: "MCQ", existlevel: 5, value: "mcq" },

      {
        value: 'planSelling',
        existlevel: 1,
        label: 'Plan Selling',
      },
      {
        value: 'fpRos',
        existlevel: 1,
        label: 'FP RoS',
      },
      {
        value: 'stores',
        existlevel: 1,
        label: 'Stores',
      },
      {
        value: 'fpSalesUnits',
        existlevel: 1,
        label: 'FP Sales Units',
      },
      // {
      //   value: "fpSalesValue",
      //   existlevel: 1,
      //   label: "FP Sales Value",
      // },
      {
        value: 'fpSlsMix',
        existlevel: 1,
        label: 'FP Sls Mix %',
      },
      {
        value: 'mdSalesUnits',
        existlevel: 1,
        label: 'MD Sales Units',
      },
      {
        value: 'markDown',
        existlevel: 1,
        label: 'MD%',
      },
      // {
      //   value: "mdSalesValue",
      //   existlevel: 1,
      //   label: "MD Sales Value",
      // },
      // {
      //   value: "mdSlsMix",
      //   existlevel: 1,
      //   label: "MD Sls Mix %",
      // },
      {
        value: 'terminal',
        existlevel: 1,
        label: 'Terminal %',
      },
      {
        value: 'terminalUnits',
        existlevel: 1,
        label: 'Terminal Units',
      },
      {
        value: 'totalUKBuyUnits',
        existlevel: 1,
        label: 'Total UK Buy Units',
      },
      // {
      //   value: "totalSalesValue",
      //   existlevel: 1,
      //   label: "Total Sales Value",
      // },
      // {
      //   value: "fpSellThrougn",
      //   existlevel: 1,
      //   label: "FP Sell Through %",
      // },
      // {
      //   value: "totalSellThrougn",
      //   existlevel: 1,
      //   label: "Total Sell Through %",
      // },
      {
        value: 'sizeRatio',
        existlevel: 7,
        label: 'Size Ratio',
      },
      {
        value: 'lengthRatio',
        existlevel: 8,
        label: 'Length Ratio',
      },
      {
        value: 'merchOptionNumber',
        existlevel: 1,
        label: 'Merch Option Number',
      },
      // {
      //   value: "ukRetailCv",
      //   existlevel: 1,
      //   label: "UK Retail Cv",
      // },
      // {
      //   existlevel: 1,
      //   label: "UK Retail Sv Net",
      //   value: "ukRetailSvNet",
      // },
      // {
      //   value: "vat",
      //   existlevel: 5,
      //   label: "VAT",
      // },
      // {
      //   value: "ukRetailSvGross",
      //   existlevel: 1,
      //   label: "UK Retail Sv Gross",
      // },
      // {
      //   value: "ukRetailMarginPer",
      //   existlevel: 1,
      //   label: "UK Retail Margin %,",
      // },
      // {
      //   value: "unitsRetail",
      //   existlevel: 1,
      //   label: "Units Retail",
      // },
      // {
      //   value: "costRetail",
      //   existlevel: 1,
      //   label: "Cost Retail",
      // },
      {
        value: 'unitsGlobal',
        existlevel: 1,
        label: 'Units Global',
      },
      // {
      //   value: "costGlobal",
      //   existlevel: 1,
      //   label: "Cost Global",
      // },
      {
        value: 'unitMOQShortfall',
        existlevel: 1,
        label: 'Unit MOQ Shortfall',
      },
      // {
      //   value: "costMOQShortfall",
      //   existlevel: 1,
      //   label: "Cost MOQ Shortfall",
      // },
    ],
    displayLevel: 1,
    ukDisplay: pathName1.includes('cathkidston'),
    selectedDisplayColumn: [],
    addEditBottomAccess: CheckActionPermission(logInRights, 'planning', 'bottomUp', 'addEdit'),
    deleteBottomAccess: CheckActionPermission(logInRights, 'planning', 'bottomUp', 'delete'),
    topDownDisplay: CheckModulePermission(logInRights, 'planning', 'topDown', isCompanyAdminLoggedIn),
    BottomUpDisplay: CheckModulePermission(logInRights, 'planning', 'bottomUp', isCompanyAdminLoggedIn),
  };
  const [planningBottomup, setPlanningBottomup] = useState(initialSetting);
  const { selectedLevel } = planningBottomup;

  const tableHeadArray = [
    {
      label: 'Product Number',
      sequence: 1,
      existlevel: 5,
      display: false,
      key: 'number',
      keyName: 'number',
    },
    // {
    //   label: "Suffix",
    //   sequence: 2,
    //   existlevel: 6,
    //   display: false,
    //   key: "suffix",
    //   keyName: "suffix",
    // },
    // {
    //   label: "Costing Code",
    //   sequence: 3,
    //   existlevel: 5,
    //   display: false,
    //   key: "costing",
    //   keyName: "costing",
    // },
    {
      label: 'SKU',
      sequence: 4,
      existlevel: 7,
      display: false,
      key: 'SKU',
      keyName: 'SKU',
    },
    {
      label: category1,
      sequence: 5,
      existlevel: 1,
      display: false,
      key: 'catOneId',
      keyName: 'catOneId',
      subKey: 'name',
    },
    {
      label: category2,
      sequence: 7,
      existlevel: 2,
      display: false,
      key: 'catTwoId',
      keyName: 'catTwoId',
      subKey: 'name',
    },
    {
      label: category3,
      sequence: 8,
      existlevel: 3,
      display: false,
      key: 'catThreeId',
      keyName: 'catThreeId',
      subKey: 'name',
    },
    {
      label: category4,
      sequence: 9,
      existlevel: 4,
      display: false,
      key: 'catFourId',
      keyName: 'catFourId',
      subKey: 'name',
    },
    {
      label: 'Product Description',
      sequence: 10,
      existlevel: 5,
      display: false,
      key: 'description',
      keyName: 'description',
    },
    {
      label: 'Colour Name',
      sequence: 12,
      existlevel: 6,
      display: false,
      keyName: 'colourName',
      key: 'colour',
      subKey: 'name',
    },
    {
      label: 'Colour Description',
      sequence: 12,
      existlevel: 6,
      display: false,
      keyName: 'colourDescription',
      key: 'colour',
      subKey: 'description',
    },
    {
      label: 'Colour Ref',
      sequence: 12,
      existlevel: 6,
      display: false,
      keyName: 'colourRef',
      key: 'colour',
      subKey: 'references',
    },
    {
      label: 'Size',
      sequence: 13,
      existlevel: 7,
      display: false,
      key: 'size',
      keyName: 'size',
    },
    {
      label: 'Length',
      sequence: 14,
      existlevel: 8,
      display: false,
      key: 'length',
      keyName: 'length',
      subKey: 'name',
    },
    // {
    //   label: "RRP",
    //   sequence: 15,
    //   existlevel: 5,
    //   display: false,
    //   key: "rrp",
    //   keyName: "rrp",
    // },
    // {
    //   label: "GBB",
    //   sequence: 16,
    //   existlevel: 5,
    //   display: false,
    //   key: "gbb",
    //   keyName: "gbb",
    // },
    {
      label: 'Season',
      sequence: 17,
      existlevel: 1,
      display: false,
      key: 'seasonId',
      keyName: 'seasonId',
      subKey: 'name',
    },
    {
      label: 'Year',
      sequence: 18,
      existlevel: 1,
      display: false,
      key: 'year',
      keyName: 'year',
    },
    {
      label: 'MOQ',
      sequence: 19,
      existlevel: 5,
      display: false,
      key: 'moq',
      keyName: 'moq',
    },
    // {
    //   label: "MCQ",
    //   sequence: 20,
    //   existlevel: 5,
    //   display: false,
    //   key: "mcq",
    //   keyName: "mcq",
    // },
  ];

  useEffect(() => {
    const setData = async () => {
      if (isArray(PlanningBottomData)) {
        const calculatedArray = [];

        if (selectedLevel?.level >= 6) {
          await Promise.all(
            PlanningBottomData.map(async (data) => {
              let currenObj = data;
              const totalPWS = await caluculateTotalPWS(currenObj);
              set(currenObj, 'totalPWS', totalPWS);
              const { fpSalesUnits, fpSalesValue } = await caluculateFPSSales(currenObj);
              currenObj = { ...currenObj, fpSalesUnits, fpSalesValue };
              set(currenObj, 'fpSalesUnits', fpSalesUnits);
              set(currenObj, 'fpSalesValue', fpSalesValue);
              currenObj = await calculateMd(currenObj);
              currenObj = await calculateTerminal(currenObj, selectedLevel?.level);
              calculatedArray.push(currenObj);
            }),
          );
        } else {
          await Promise.all(
            PlanningBottomData.map(async (data) => {
              const currenObj = data;
              const totalPWS = await caluculateTotalPWS(currenObj);
              set(currenObj, 'totalPWS', totalPWS);
              calculatedArray.push(currenObj);
            }),
          );
        }
        setPlanningBottomup((prev) => ({
          ...prev,
          planningBottomProducts: calculatedArray,
        }));
      }
    };
    setData();
  }, [PlanningBottomData, selectedLevel?.level]);

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem('loggedInUserInfo'));
    if (userData?.lengthVisible !== null && userData?.lengthVisible !== undefined) {
      setLengthEnabled(userData?.lengthVisible);
    }
  }, []);

  const memoizedContextValue = useMemo(() => {
    const checkVisibleBottomUp = (keyName) => {
      const getKeyData = planningBottomup.selectedDisplayColumn?.find((ele) => ele === keyName);
      return !!getKeyData;
    };
    return {
      _id: '1',
      planningBottomup,
      setPlanningBottomup,
      checkVisibleBottomUp,
      tableHeadArray,
      lengthEnabled,
    };
  }, [planningBottomup, setPlanningBottomup, tableHeadArray, lengthEnabled]);

  return <StateContext.Provider value={memoizedContextValue}>{children}</StateContext.Provider>;
}

export function usePlanningBottomupState() {
  const context = useContext(StateContext);
  if (!context) {
    throw new Error('useAppState must be used within the PlanningBottomStateProvider');
  }
  return context;
}
